export default "__VITE_ASSET__Cu3G3fKL__"